import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Paper, MenuItem } from '@mui/material';
import { withStyles } from '@mui/styles';

import { Checkbox } from '../../inputs';
import SelectClasses from './MultiSelectStyles';

const Blanket = (props: any) => <Paper {...props} />;

// @ts-expect-error TS(2345): Argument of type '({ config, palette, ...theme }: ... Remove this comment to see the full error message
export const Menu = withStyles(SelectClasses)((props: any) => {
  return (
    <Paper square className={props.classes.paper}>
      {props.children}
    </Paper>
  );
});

export function Dropdown({ children, isOpen, target }: any) {
  return (
    <div style={{ position: 'relative' }}>
      {target}
      {isOpen ? <Menu>{children}</Menu> : null}
      {isOpen ? <Blanket /> : null}
    </div>
  );
}

export function DropdownIndicator() {
  return <SearchIcon />;
}

export function Option(props: any) {
  return (
    <MenuItem
      className={props.selectProps.classes.menuItem}
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.isMulti ? (
        <React.Fragment>
          <Checkbox checked={props.isSelected} /> {props.children}
        </React.Fragment>
      ) : (
        <div
          style={{
            paddingLeft: '10px',
            paddingRight: '10px',
          }}
        >
          {props.children}
        </div>
      )}
    </MenuItem>
  );
}

// @ts-expect-error TS(2345): Argument of type '({ config, palette, ...theme }: ... Remove this comment to see the full error message
export const MenuList = withStyles(SelectClasses)((props: any) => {
  const { selectProps } = props;
  const { value, options } = selectProps;
  const allSelected = value.length === options.length;

  return (
    <div
      className={`${props.selectProps.className ?? ''} ${
        props.selectProps.classes.menuList
      }`}
      id="menu-list"
    >
      {props.selectProps.supportSelectAll && (
        <Box
          className={props.classes.newLegendItem}
          onClick={selectProps.toggleAllHandler}
        >
          <Checkbox checked={allSelected} />

          <p className={props.classes.legendText}>
            {allSelected ? 'Unselect All' : 'Select All'}
          </p>
        </Box>
      )}
      {props.children}
    </div>
  );
});
